import { CTASection } from "../shared/cta-section";

export const CTA = () => {
  return (
    <CTASection
      id="act-cta"
      title="Ready to transform your environmental monitoring?"
      description="Leverage the same AI-enhanced satellite analysis and interactive platforms that informed legislative change in the ACT. Contact Haizea Analytics to learn how our technology can deliver evidence-based insights for your environmental policy and planning decisions."
      buttons={[
        {
          text: "Start Your Analysis",
          href: "mailto:contact@haizea.com.au",
          backgroundColorClass: "bg-haizea-orange",
        },
        {
          text: "Explore ACT Platform",
          href: "https://act.terrak.io/",
          backgroundColorClass: "bg-haizea-blue",
        },
      ]}
    />
  );
};
